import angular from 'angular'
import routers from './routers.js'
import reportTaskTrackingCtrl from './reportTaskTrackingCtrl.js'

export default angular
  .module('declaration.vatDeclarationSurcharges.reportTaskTracking', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config)
      })
    },
  ])
  .controller('reportTaskTrackingCtrl', reportTaskTrackingCtrl).name



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/reportTaskTracking/index.js